import { render, staticRenderFns } from "./CoordinatorDesignation.vue?vue&type=template&id=4135f7a8&"
import script from "./CoordinatorDesignation.vue?vue&type=script&lang=js&"
export * from "./CoordinatorDesignation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports